const events = [
  {
    name: 'Kickoff Ceremony',
    weekday: 'Mon',
    shortDate: 11,
    info: 'Mon 10/11 @ 6PM PST • ICSSC • <a href="https://uci.zoom.us/j/91907202064">Zoom link</a>',
    description: 'Come out to our opening ceremony to learn about the schedule, rules, and resources for WebJam! We will also be going over all of the exciting workshops we have planned for the week, so make sure to come by to learn more.'
  },
  {
    name: 'Basics of UI/UX',
    weekday: 'Mon',
    shortDate: 11,
    info: 'Mon 10/11 @ 8PM PST • Design at UCI • <a href="https://uci.zoom.us/j/93085544467">Zoom link</a>',
    description: 'This workshop will go over the fundamentals of both UI and UX. A brief introduction about each part will be given to ensure that attendees have a good understanding of the differences between the two, as well as how the two sections overlap. The UI section will go over basic visual design principles. The UX section will explain common layout designs and practices.'
  },
  {
    name: 'Introduction to APIs',
    weekday: 'Tue',
    shortDate: 12,
    info: 'Tue 10/12 @ 7PM PST • ICSSC Projects • <a href="https://uci.zoom.us/j/97145013174">Zoom link</a>',
    description: "Learn how to use APIs in web development and how they can enhance your project. The workshop will also introduce ICSSC Projects' very own PeterPortal API."
  },
  {
    name: 'Intro to React',
    weekday: 'Tue',
    shortDate: 12,
    info: 'Tue 10/12 @ 8:30PM PST • ICSSC • <a href="https://uci.zoom.us/j/92725260380">Zoom link</a>',
    description: "Build an interactive website with React, the most popular web dev framework around! You'll learn what React actually is and explore some of its building blocks — components, props, state, and events — and the role each plays in a React app. We'll also be adding Dark Mode to this website in the Dark Mode workshop Thursday night!"
  },
  {
    name: 'Introduction to Python Flask',
    weekday: 'Wed',
    shortDate: 13,
    info: 'Wed 10/13 @ 8PM PST • WICS • <a href="https://uci.zoom.us/j/94632240042">Zoom link</a>',
    description: "<p>Learn the basics of Python Flask and create a basic end-to-end web app through an interactive workshop hosted by WICS!</p><p>(note: our presenters ask that you clone <a href='https://github.com/WICSOutreach/webjam-web-dev-workshop'>this repository</a> and set things up beforehand so that you are ready to go with the workshop! Need help? Here's a <a href='https://docs.github.com/en/repositories/creating-and-managing-repositories/cloning-a-repository'>guide</a> on how to clone a repo)</p>",
  },
  {
    name: 'Introduction to SQL',
    weekday: 'Thu',
    shortDate: 14,
    info: 'Thu 10/14 @ 7PM PST • MAISS • <a href="https://uci.zoom.us/j/93913207887">Zoom link</a>',
    description: 'Learn the applications of SQL through an introductory, interactive workshop hosted by MAISS.'
  },
  {
    name: 'Add Dark Mode to your website',
    weekday: 'Thu',
    shortDate: 14,
    info: 'Thu 10/14 @ 8:30PM PST • ICSSC • <a href="https://uci.zoom.us/j/92333590113">Zoom link</a>',
    description: "The React app you made with us on Tuesday is about to get a fresh coat of dark paint! Along the way, you'll also learn why you should add this sleek new look to your website, and best design/coding practices to guarantee a great experience for your user. (if you didn't attend the Intro to React workshop on Tuesday that's fine too, we'll provide source code!)"
  },
  {
    name: 'Presentations & Closing Ceremony',
    weekday: 'Fri',
    shortDate: 15,
    info: 'Fri 10/15 @ 5PM PST • DBH 6011',
    description: 'WebJam comes to a close with our prize ceremony! As the only IN-PERSON event during the week, this ceremony will allow you to present your projects in front of our esteemed judges and audience for the chance to win some cool prizes.'
  }
];

export default events;
